// import React from 'react'
// import { NavLink } from 'react-router-dom';
// import styled from 'styled-components';
// import { Github } from '../components/AllSvgs';
// import { motion } from 'framer-motion';


// const Box = styled(motion.li)`
// width: 16rem;
// height: 40vh;
// background-color: ${props => props.theme.text};
// color: ${props => props.theme.body};
// padding: 1.5rem 2rem ;
// margin-right: 8rem;
// border-radius: 0 50px 0 50px;
// display: flex;
// flex-direction: column;
// justify-content: space-between;
// border: 1px solid  ${props => props.theme.body};
// transition: all 0.2s ease;

// &:hover{
// background-color: ${props => props.theme.body};
// color: ${props => props.theme.text};
// border: 1px solid  ${props => props.theme.text};

// }
// `
// const Title = styled.h2`
// font-size: calc(1em + 0.5vw);
// `
// const Description = styled.h2`
// font-size: calc(0.8em + 0.3vw);
// font-family: 'Karla', sans-serif;
// font-weight: 500;
// ` 
// const Tags = styled.div`
// border-top: 2px solid ${props => props.theme.body};
// padding-top: 0.5rem;
// display: flex;
// flex-wrap: wrap;

// ${Box}:hover &{
// border-top: 2px solid ${props => props.theme.text};
// }
// `
// const Tag = styled.span`
// margin-right: 1rem; 
// font-size: calc(0.8em + 0.3vw);
// `
// const Footer = styled.footer`
// display: flex;
// justify-content: space-between;
// `

// const Link = styled.a`
// background-color:  ${props => props.theme.body};
// color:  ${props => props.theme.text};
// text-decoration: none;
// padding: 0.5rem calc(2rem + 2vw);
// border-radius: 0 0 0 50px;
// font-size: calc(1em + 0.5vw);

// ${Box}:hover &{
//    background-color:  ${props => props.theme.text};
//     color:  ${props => props.theme.body};
//     }
// `

// const Git = styled.a`
// color: inherit;
// text-decoration: none;

// ${Box}:hover &{
//    &>*{
//     fill: ${props => props.theme.text};
//    }
// }
// `

// // const ImageWrapper = styled.div`
// //   width: 100%;
// //   height: 60%;
// //   overflow: hidden;
// //   border-radius: 10px;
// //   margin-bottom: 1rem;

// //   img {
// //     width: 100%;
// //     height: 100%;
// //     object-fit: cover;
// //     transition: transform 0.3s ease;
// //   }

// //   ${Box}:hover & img {
// //     transform: scale(1.05);
// //   }
// // `;

// // framer config.
// const item = {
//     hidden: {
//         scale: 0
//     },
//     show:{
//         scale:1,
//         transition: {
//             type: 'spring',
//             duration: 0.8
//         }
//     }
// }

// const Card = (props) => {
//     const { id, name, description, tags, demo, github } = props.data;

//     return (
//         // wrap in nav link to make each component clickable for later 
//         <NavLink
//             to={`/work/${id}`}
//             state={{ project: props.data }}
//             style={{ textDecoration: 'none' }}
//         >
//         <Box key={id} variants={item}>
//             {/* Image dominates the top section */}
//             {/* <ImageWrapper>
//                 <img src={image} alt={name} />
//             </ImageWrapper> */}

//             <Title>{name}</Title>
//             <Description>{description}</Description>

//             <Tags>
//                 {tags.map((t, id) => (
//                     <Tag key={id}>#{t}</Tag>
//                 ))}
//             </Tags>

//             <Footer>
//                 <Link href={demo} target="_blank" rel="noopener noreferrer">
//                     Visit
//                 </Link>
//                 <Git href={github} target="_blank" rel="noopener noreferrer">
//                     <Github width={30} height={30} />
//                 </Git>
//             </Footer>
//         </Box>
//          </NavLink>
//     );
// };

// export default Card;



import React from 'react'
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Github } from '../components/AllSvgs';
import { motion } from 'framer-motion';

const Box = styled(motion.li)`
width: 16rem;
height: 40vh;
background-color: ${props => props.theme.text};
color: ${props => props.theme.body};
padding: 1.5rem 2rem ;
margin-right: 8rem;
border-radius: 0 50px 0 50px;
display: flex;
flex-direction: column;
justify-content: space-between;
border: 1px solid  ${props => props.theme.body};
transition: all 0.2s ease;

&:hover{
background-color: ${props => props.theme.body};
color: ${props => props.theme.text};
border: 1px solid  ${props => props.theme.text};
}
`
const Title = styled.h2`
font-size: calc(1em + 0.5vw);
`
const Description = styled.h2`
font-size: calc(0.8em + 0.3vw);
font-family: 'Karla', sans-serif;
font-weight: 500;
`
const Tags = styled.div`
border-top: 2px solid ${props => props.theme.body};
padding-top: 0.5rem;
display: flex;
flex-wrap: wrap;

${Box}:hover &{
border-top: 2px solid ${props => props.theme.text};
}
`
const Tag = styled.span`
margin-right: 1rem;
font-size: calc(0.8em + 0.3vw);
`
const Footer = styled.footer`
display: flex;
justify-content: space-between;
`

const Link = styled.a`
background-color:  ${props => props.theme.body};
color:  ${props => props.theme.text};
text-decoration: none;
padding: 0.5rem calc(2rem + 2vw);
border-radius: 0 0 0 50px;
font-size: calc(1em + 0.5vw);

${Box}:hover &{
   background-color:  ${props => props.theme.text};
    color:  ${props => props.theme.body};
    }
`

const Git = styled.a`
color: inherit;
text-decoration: none;

${Box}:hover &{
   &>*{
    fill: ${props => props.theme.text};
   }
}
`

// framer config.
const item = {
    hidden: {
        scale: 0
    },
    show: {
        scale: 1,
        transition: {
            type: 'spring',
            duration: 0.8
        }
    }
}

const Card = (props) => {
    const { id, name, description, tags, demo, github, type, paper, pdf, code } = props.data;

    const isResearch = type === 'research';
    const primaryHref = isResearch ? (paper || pdf) : demo;
    const primaryLabel = isResearch ? 'Read' : 'Visit';
    const secondaryHref = isResearch ? code : github;

    // stop the card's NavLink from also firing when an inner link is clicked
    const stop = (e) => e.stopPropagation();

    return (
        <NavLink
            to={`/work/${id}`}
            state={{ project: props.data }}
            style={{ textDecoration: 'none' }}
        >
            <Box key={id} variants={item}>
                <Title>{name}</Title>
                <Description>{description}</Description>

                <Tags>
                    {tags.map((t, i) => (
                        <Tag key={i}>#{t}</Tag>
                    ))}
                </Tags>

                <Footer>
                    {primaryHref ? (
                        <Link href={primaryHref} target="_blank" rel="noopener noreferrer" onClick={stop}>
                            {primaryLabel}
                        </Link>
                    ) : <span />}
                    {secondaryHref && (
                        <Git href={secondaryHref} target="_blank" rel="noopener noreferrer" onClick={stop}>
                            <Github width={30} height={30} />
                        </Git>
                    )}
                </Footer>
            </Box>
        </NavLink>
    );
};

export default Card;